$(document).ready(function () {
  const triggerModal = (clickedSlide) => {
    clickedSlide.classList.add("active");
    const modal = document.getElementById(clickedSlide.dataset.modalId);
    if (modal) {
      modal.classList.add("active");
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      modal.addEventListener("click", (event) => {
        if (
          !event.target.closest(".featured-articles-modal__close") &&
          event.target.closest(".featured-articles-modal__card")
        )
          return;

        modal.classList.remove("active");
        clickedSlide.classList.remove("active");
      });
    }
  };

  const swiper = new Swiper(
    ".featured-articles  .featured-articles-items.swiper-container",
    {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".featured-articles .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.4,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 23,
        },
      },
      on: {
        click: function (swiper, event) {
          const clickedSlide = event.target.closest(".swiper-slide");
          if (!clickedSlide) return;

          triggerModal(clickedSlide);
        },
      },
    },
  );
});
